import React, { type FC } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import type { PromotedEntities } from '../../../../BettingMenu/types';
import type { ReduxState } from 'app/redux/types';

import { TournamentsMenuItems } from '../../../components/TournamentsMenu';
import { tournamentsMenuLayersByPathname } from '../../../selectors/prematch';

type PrematchTournamentsMenuLayerProps = {
  promotedEntities: PromotedEntities;
};

export const PrematchTournamentsMenuLayer: FC<PrematchTournamentsMenuLayerProps> = ({
  promotedEntities,
}) => {
  const { pathname } = useLocation();

  const entry = useSelector((state: ReduxState) => tournamentsMenuLayersByPathname(state, pathname)
    .find((layer) => layer.visible));

  return (
    <>
      {entry && (
        <TournamentsMenuItems list={entry?.items}
                              promotedEntities={promotedEntities} />
      )}
    </>
  );
};
